import { render, staticRenderFns } from "./AboutDrug.vue?vue&type=template&id=1b8902c4"
import script from "./AboutDrug.vue?vue&type=script&lang=js"
export * from "./AboutDrug.vue?vue&type=script&lang=js"
import style0 from "./AboutDrug.vue?vue&type=style&index=0&id=1b8902c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports